import { useEffect } from "react";
import { Mail } from "lucide-react";
import Nav from "../components/site/Nav";

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main
      data-testid="about-page"
      className="min-h-screen bg-[var(--bg)] text-[var(--ink)] font-sans"
    >
      <Nav />

      {/* Intro */}
      <section className="border-b border-stone-300">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 pt-6 pb-20 md:pt-8 md:pb-28">
          <p
            data-testid="about-lead"
            className="font-serif text-stone-900 text-2xl sm:text-3xl lg:text-4xl leading-[1.2] tracking-tight max-w-4xl"
          >
            The Election Competition Center is a nonpartisan research group. We
            focus on developing high-quality, trustworthy research materials
            that combine academic rigor with an understanding of political
            reality, but the ECC is not affiliated with any individual reform
            movement, party, campaign, ideology, or institution.
          </p>
        </div>
      </section>

      {/* Legal */}
      <section
        data-testid="legal-section"
        className="border-b border-stone-300 bg-stone-100/30"
      >
        <div className="max-w-6xl mx-auto px-6 sm:px-10 py-20 md:py-24">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
            <div className="md:col-span-5">
              <p className="font-mono-label text-stone-500">Legal</p>
            </div>
            <div className="md:col-span-7">
              <p
                data-testid="legal-text"
                className="font-serif text-stone-900 text-xl sm:text-2xl leading-snug max-w-3xl"
              >
                The Election Competition Center is a nonpartisan research
                project fiscally sponsored by Global Impact (
                <a
                  href="https://charity.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="charity-link"
                  className="underline decoration-stone-400 underline-offset-4 hover:decoration-stone-900 transition-colors"
                >
                  www.charity.org
                </a>
                ), a 501(c)(3) nonprofit organization (EIN 52-1273585).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section
        id="contact"
        data-testid="contact-section"
        className="border-b border-stone-300"
      >
        <div className="max-w-6xl mx-auto px-6 sm:px-10 py-24 md:py-32">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
            <div className="md:col-span-5">
              <p className="font-mono-label text-stone-500">Contact</p>
            </div>

            <div className="md:col-span-7">
              <p className="font-serif text-stone-900 text-xl sm:text-2xl leading-snug max-w-3xl">
                Whether you&apos;re a journalist, scholar, elected official,
                election administrator, or curious member of the public,
                we&apos;d like to hear from you. Send us a note with research
                questions, dataset requests, collaboration proposals, or
                corrections.
              </p>

              <a
                href="mailto:info@electioncompetition.org"
                data-testid="contact-email"
                className="mt-10 inline-flex items-center gap-4 border border-stone-900 hover:bg-stone-900 hover:text-stone-50 transition-colors px-6 py-5 group"
              >
                <Mail className="w-5 h-5 shrink-0" strokeWidth={1.5} />
                <span className="font-mono text-sm sm:text-base break-all">
                  info@electioncompetition.org
                </span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
